import { Modal, Result } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button, UncontrolledTooltip } from "reactstrap";

const CreateStatusNotification = ({
  isOpen,
  status,
  successOrderCode,
  toggleNotification,
}) => {
  const { t } = useTranslation(["bloodOrder"]);
  const navigate = useNavigate();

  const handleContinue = () => {
    toggleNotification();
  };

  const handleExit = () => {
    navigate(-1);
  };

  return (
    <Modal title="" visible={isOpen} closeIcon={<></>} footer={null}>
      <Result
        status={status || "error"}
        title={t(`message.${status}`)}
        subTitle={
          <div className="d-flex flex-column align-items-center">
            <span>{t(`message.create_order_${status}`)}</span>
            {status === "success" && (
              <span>
                Mã đơn: {successOrderCode}
                <Button
                  id={`success-order-code`}
                  size="sm"
                  color=""
                  className="bg-light"
                  onClick={e => navigator.clipboard.writeText(successOrderCode)}
                >
                  <i className="far fa-copy fa-md text-secondary" />
                </Button>
                <UncontrolledTooltip
                  placement="top"
                  target={`success-order-code`}
                >
                  Copy
                </UncontrolledTooltip>
              </span>
            )}
          </div>
        }
        extra={[
          <Button color="warning" onClick={handleExit}>
            Thoát khỏi tạo đơn
          </Button>,
          <Button color="primary" onClick={handleContinue}>
            Tiếp tục tạo đơn
          </Button>,
        ]}
      />
    </Modal>
  );
};

export default CreateStatusNotification;
